import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Transfer16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_467)'>
      <path
        d='M15.0608 4.5L11.0304 0.469666L9.96978 1.53033L12.1895 3.75L2.00011 3.75V5.25H12.1894L9.96978 7.46967L11.0304 8.53033L15.0608 4.5Z'
        fill='currentColor'
      />
      <path
        d='M0.939453 11.5L4.96978 15.5303L6.03044 14.4697L3.81077 12.25L14.0001 12.25V10.75L3.81078 10.75L6.03044 8.53033L4.96978 7.46967L0.939453 11.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_467'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Transfer16.displayName = 'Transfer16';
export default Transfer16;
